import React from "react";
import { SECTION_TYPE_LABELS } from "../utils/constants";
import "../styles/SectionList.css";

const SectionList = ({ sections, onEdit, onDelete, onMove, onReclassify }) => {
  if (!sections || sections.length === 0) {
    return null;
  }

  const getTypeColor = (type) => {
    const colors = {
      h1: "#667eea",
      h2: "#764ba2",
      h3: "#a97fb8",
      h: "#b8a7d8",
      p: "#6b7280",
      ul: "#10b981",
      c: "#f59e0b",
      md: "#3b82f6",
      table: "#8b5cf6",
      btn: "#ec4899",
      yt: "#ef4444",
      resources: "#06b6d4",
      alert: "#f97316",
    };
    return colors[type] || "#9ca3af";
  };

  const getTruncated = (content, maxLen = 60) => {
    if (typeof content !== "string") return JSON.stringify(content).slice(0, maxLen);
    return content.length > maxLen ? content.slice(0, maxLen) + "..." : content;
  };

  return (
    <div className="section-list-container">
      <div className="list-header">
        <h3>📋 Parsed Sections ({sections.length})</h3>
        <p className="list-hint">Click to edit or reclassify sections</p>
      </div>

      <div className="sections-grid">
        {sections.map((section, index) => {
          const [type, content] = section;
          const label = SECTION_TYPE_LABELS[type] || type;

          return (
            <div key={index} className="section-card">
              <div className="section-header">
                <div className="section-badge" style={{ backgroundColor: getTypeColor(type) }}>
                  {type}
                </div>
                <span className="section-index">#{index + 1}</span>
              </div>

              <div className="section-content">
                <p className="content-preview">{getTruncated(content)}</p>
              </div>

              <div className="section-type">
                <span>{label}</span>
              </div>

              <div className="section-actions">
                <button
                  className="action-btn edit"
                  title="Edit this section"
                  onClick={() => onEdit(index)}
                >
                  ✎ Edit
                </button>

                <button
                  className="action-btn reclassify"
                  title="Change section type"
                  onClick={() => onReclassify(index)}
                >
                  🔄 Classify
                </button>

                {index > 0 && (
                  <button
                    className="action-btn move-up"
                    title="Move up"
                    onClick={() => onMove(index, "up")}
                  >
                    ↑
                  </button>
                )}

                {index < sections.length - 1 && (
                  <button
                    className="action-btn move-down"
                    title="Move down"
                    onClick={() => onMove(index, "down")}
                  >
                    ↓
                  </button>
                )}

                <button
                  className="action-btn delete"
                  title="Delete this section"
                  onClick={() => {
                    if (window.confirm("Delete this section?")) {
                      onDelete(index);
                    }
                  }}
                >
                  ✕
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SectionList;
